import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { Subscription } from 'rxjs';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { ServiceViewModel } from '../../../business-entities/service-view-model';
import { FuelTypeForMultiselect, ServiceFilterViewModel, ServiceTimeDetailViewModel } from '../../../business-entities/ServiceFilter-viewModel';
import { BrandType, VehicleType } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { CheckListBusinessService } from '../../../business-services/check-list.service';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { ServicesService } from '../../../business-services/services.service';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from '../../../business-entities/user-role-view-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { SpecialToolBusinessService } from '../../../business-services/special-tool.service';
import { SpecialToolType } from '../../../business-entities/special-tool-model';
import { WarningLightListModel } from '../../../business-entities/warning-light-view-model';
import { WarningLightService } from '../../../business-services/warninglight.service';
import { PackageService } from '../../../business-services/package.service';
import { PackageDropdownList } from '../../../business-entities/package-list-model';
import { LaborService } from '../../../business-services/labor.service';

@Component({
  selector: 'app-add-service',
  templateUrl: './add-service.component.html'
})
export class AddServiceComponent implements OnInit, OnDestroy {
  addService = false;
  addServiceForm: FormGroup = new FormGroup({});
    image: string | ArrayBuffer;
    imageBaseData: string | ArrayBuffer = null;
    categoryList:any;
    currentlagSub: Subscription;
    languageList: any[];
    chargingGroupList:any;
    chargingGroup:any;
    competenceList:any;
    competenceActiveList:any=[];
    price:string;
    priceInclVAT:string;
    isFixed:boolean;
    makeList: BrandType[] = [];
    vehicleTypes: VehicleType[] = [];
    fuels: FuelType[] = [];
    serviceDetails:ServiceTimeDetailViewModel
    ServiceFilterForm: ServiceFilterViewModel[] = []
    allServices: ServiceViewModel[] = [];
    selectedChildServices:any[]=[];
    selectedChildServicesString:string='';
    dropdownSettings = {};
    VehicleAge = [];
    Mileage = [];
    LogicOperator=[];
    features: Features[] = [];
    integrationWithDms: boolean = false;
    realTimeDmsSyncService: boolean = false;
    specialToolTypes: SpecialToolType[] = [];
    showspecialtool : boolean = false;
    allWarningLight:WarningLightListModel[]=[];
    selectedWarningLight:any[]=[];
    selectedWarningLightString:string='';
    dropdownSettingsWarningLight={};
    isWarningLightFeature: boolean =false;
    packageDropdownList:PackageDropdownList[] = [];
    selectPackage:string = '';
    dmsServiceId:boolean=false;

    VATPercentage:number=0
    isAddView:boolean = false;
    constructor(private formBuilder: FormBuilder,
       private Service: ServicesService,
       private spinner: NgxSpinnerService,
       private toaster: ToastrService, private translate : TranslateService,
       private cookieservice: CookieService,
       private currentLanguageService: CurrentLanguage,
       private brandService: BrandService,
       private checkListService: CheckListBusinessService,
       private EditRentalCar: RentalCarService,
       private globalSetting: GlobalSetting,
       private cdr: ChangeDetectorRef,
       private activeModal : NgbActiveModal,
       private laborService: LaborService,
       private imageService:ImageService,
       private specialToolService: SpecialToolBusinessService,
       private secureStorage: SecureStorage,
       private warningLightService: WarningLightService,
       private packageService: PackageService,) {
        this.Mileage=Constant.Mileage;
        this.VehicleAge=Constant.VehicleAge;
        this.LogicOperator=Constant.LogicOperator;
       }

    ngOnInit(): void {
      this.VATPercentage=this.secureStorage.getKeyData('VATPercentage');
      this.features = this.secureStorage.getKeyData('feature');
      if ((this.features != null || this.features != undefined) && this.features.length > 0) {
          this.integrationWithDms = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
          this.realTimeDmsSyncService = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSS)?.isActive;
          this.isWarningLightFeature = this.features.find(x => x.featureCode === Enums.FeatureCode.WarningLight)?.isActive;
          this.showspecialtool = this.features.find(x => x.featureCode === Enums.FeatureCode.SpecialTool)?.isActive;
          this.dmsServiceId = this.features.find(x => x.featureCode === Enums.FeatureCode.DMSService)?.isActive;
      }
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'childService',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: false,
        maxHeight: 500
      };

      this.dropdownSettingsWarningLight = {
        singleSelection: false,
        idField: 'id',
        textField: 'warningName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 2,
        allowSearchFilter: false,
        maxHeight: 500
      };
      if (this.currentlagSub) {
        this.currentlagSub.unsubscribe();
      }
      this.languageList = this.currentLanguageService.LanguageList;
      this.serviceDetails={
        makeList:null ,
        modelList:null,
        vehicleTypes: null,
        fuels: null,
        vehicleAge:null,
        mileage:null,
        logicOperator:null

      }
      this.addServiceForm = this.formBuilder.group({
        service: new FormArray([]),
        price: [0,[Validators.required]],
        priceInclVAT: [0,[Validators.required]],
        duration: ['',[Validators.required]],
        serviceNo: ['',[Validators.required]],
        //logo: ['',],
        Image: [''],
        ImageBinaryData: [''],
        MimeType: [''],
        serviceCategoryId: ['',[Validators.required]],
        serviceExternalink:[''],
        //serviceCategoryName:[''],
        competenceId: ['',[Validators.required]],
       // competenceName: [''],
        isActive: [true],
        displayPriceInWidget: [true],
        displayInWidget: [true],
        isServiceChecked: [false],
        isFixed: [false],
        id: [0],
        OrderNumber:[''],
        isAdditionalCustomerComment:[false],
        additionalCustomerComment:new FormArray([]),
        needAttention:[false],
        recommendedService:[false],
        specialToolTypeId:[''],
        dmsServiceId: [''],
        isWarningLight:[false],
        packageNo: [''],
        chargingGroup:['']
      });
      this.getLanguage();
      this.getChargingGroupDropDown();

      this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
        this.GetAll();
        });

        let serviceFilterViewModel: ServiceFilterViewModel = {
          BrandId: null,
          VehicleTypeId: null,
          FuelTypeId: [],
          FuelId:'',
          RangeFunctionForVehicleAge:0,
          VehicleAge:null,
          LogicFunction:0,
          Mileage:null,
          RangeFunctionForMileage:0,
          Duration:null,
          Price:null,
          PriceInclVAT:null,
          IsFixedPrice:false,
          IsShowPrice:false,
          Discount:null,
          Model:null
        };
        this.ServiceFilterForm.push(serviceFilterViewModel);
        this.serviceDetails.logicOperator=this.LogicOperator;
        this.serviceDetails.vehicleAge=this.VehicleAge;
        this.serviceDetails.mileage=this.Mileage;
        this.addServiceForm.controls['chargingGroup'].disable();
    }

    async GetWarningLight() {
      let language = this.cookieservice.get('userSelectedLanguage')
      await this.warningLightService.getWarningLightDropDown(language)
        .then((response) => {
          this.allWarningLight = response;
        });
    }

    async getPackages(){
      this.spinner.show();
      let model = {
        makeCode: "",
        cultureCode: this.cookieservice.get('userSelectedLanguage'),
      }
      await this.packageService.getAfxPackageDropdown(model).then(response => {
        this.packageDropdownList = response?.responseObject;
        this.spinner.hide();
      }, _error => {
        this.spinner.hide();
      });
    }


    ngOnDestroy(): void {
      this.currentlagSub.unsubscribe();
    }

    async GetAll(){
      let language = this.cookieservice.get('userSelectedLanguage')
      this.Service.getServiceCategory(language).then(data => {
        this.categoryList = data.responseObject;
    })
    await this.getCompetence(0);
      for(let item of this.competenceList)
      {
        if(item.isActive)
        {
          this.competenceActiveList.push(item);
        }
      }
      await this.getAllServices();
      await this.GetAllMake();
      await this.GetAllVehicleTypes();
      await this.GetAllFuelTypes();
      await this.GetAllSpecialToolTypes();
      await this.getPackages();
      if(this.isWarningLightFeature)
      {
        await this.GetWarningLight();
      }
      this.cdr.detectChanges();
    }

    async getCompetence(status:number)
    {
       await this.Service.getCompetence(status).then(resp=>{
        this.competenceList=resp.responseObject;
      })
    }

    get cpf() {
      return this.addServiceForm.controls;
    }

    get t() { return this.cpf.service as FormArray; }

    get c() { return this.cpf.additionalCustomerComment as FormArray; }

    getLanguage() {
      const number = this.currentLanguageService.LanguageList.length;
      if (this.t.length < number) {
          for (let i = this.t.length; i < number; i++) {
              this.t.push(this.formBuilder.group({
                  languageId: ['',],
                  name: ['', Validators.required],
                  description: ['', Validators.required],
                  internaldescription: ['', Validators.required],
              }));
          }
      } else {
          for (let i = this.t.length; i >= number; i--) {
              this.t.removeAt(i);
          }
      }

      if (this.c.length < number) {
        for (let i = this.c.length; i < number; i++) {
          this.c.push(this.formBuilder.group({
            languageId: ['',],
            name: ['', ],
          }));
        }
      } else {
        for (let i = this.c.length; i >= number; i--) {
          this.c.removeAt(i);
        }
      }
  }

  RemoveLogo(){
    this.addServiceForm.value.Image = "";
    this.addServiceForm.value.ImageBinaryData = "";
    this.image = "";
  }

    onChangeFileUpload(files: FileList) {
      const me = this;
      const file = files[0];
      this.addServiceForm.controls["MimeType"].setValue(files[0].type);
      this.addServiceForm.controls["Image"].setValue(files[0].name);
      let imageSize = files[0].size;
      let imgerrormsg = this.translate.instant("lblAllowedJPGPNGSVG");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const isValidFormat=this.imageService.validateImageFormat(this.addServiceForm.value.MimeType);
      if(isValidFormat)
      {
        if(imageSize < 100000)
        {
          reader.onload = (_readerEvent) => {
            me.imageBaseData = reader.result;
            this.addServiceForm.controls["ImageBinaryData"].setValue(reader.result.toString().replace('data:' + this.addServiceForm.value.MimeType + ';base64,', ''));
            this.image = me.imageBaseData;
            };
        }
        else
        {
          let errormsg = this.translate.instant("lblSizeExceedError");
          this.toaster.error(errormsg);
        }

     }

     else {
      this.toaster.error(imgerrormsg);
    }
      reader.onerror = function (_error) {
        // This is intentional
      };
    }

    onBlur(event) {
      this.price = event.target.value;
      let priceVal= JSON.parse(JSON.stringify(event.target.value));
      this.priceInclVAT = Utility.GetPriceInludingVAT(priceVal,this.VATPercentage).toString();
    }
    
    empty(e: any) {
      switch (e) {
        case "":
        case null:
        case undefined:
          return true;
        default:
          return false;
      }
    }

    AddService() {
      this.addService = true;
      if (this.addServiceForm.invalid) {
        return;
      }
      let customerCommentlable:any=[];
      if(this.addServiceForm.value.isAdditionalCustomerComment)
      {
        this.addServiceForm.value.additionalCustomerComment.forEach(element => {
          if(!element.name)
          {
            let errorMessage = this.translate.instant("lblErrorMessage");
            this.toaster.error(errorMessage);
          }
        });
        customerCommentlable=this.addServiceForm.value.additionalCustomerComment
      }
      let isDiscountError = this.checkDiscountErrors()
      if(isDiscountError)
      {
        let msg = this.translate.instant("lblDiscountBetween1to100")
        this.toaster.error(msg);
        return
      }

      let errorMessage = this.translate.instant("lblErrorMessage");
      let WarningMessage = this.translate.instant("lblErrorWarningForValue")
      let duration = Utility.ConvertTimeToMinutes(this.addServiceForm.value.duration)
      if(duration > 1200)
      {
        let errormsg = this.translate.instant("lblExceedDurationtimelimit");
        this.toaster.error(errormsg);
        return;
      }
     this. processServiceFilterForm();

      if(this.selectedChildServices.length>0)
      {
        this.selectedChildServices.forEach(element => {
          this.selectedChildServicesString +=element.id +','
        });
      }
     this.processWarningLight()

      let viewModel = {
        Lnlnvalue: this.addServiceForm.value.service,
        Price: this.globalSetting.getFormattedprice(this.addServiceForm.value.price),
        Duration: duration,
        Id: 0,
        IsActive: this.addServiceForm.value.isActive,
        Image:  this.addServiceForm.value.Image ?? "",
        MimeType: this.addServiceForm.value.MimeType ?? "",
        ImageBinaryData: this.addServiceForm.value.ImageBinaryData ?? "",
        DisplayPriceInWidget: this.addServiceForm.value.displayPriceInWidget,
        DisplayInWidget:this.addServiceForm.value.displayInWidget,
        ServiceCategoryId: this.addServiceForm.controls['serviceCategoryId'].value,
        ServiceExternalink: this.addServiceForm.controls['serviceExternalink'].value,
        IsFixed:this.addServiceForm.value.isFixed,
        CompetenceId: this.addServiceForm.controls['competenceId'].value,
        OrderNumber: this.addServiceForm.value.OrderNumber,
        ServiceNo: this.addServiceForm.value.serviceNo,
        ServiceFilterList:this.ServiceFilterForm,
        DeletedServiceFilterList:'',
        ChildServices :this.selectedChildServicesString,
        IsAdditionalCustomerComment:this.addServiceForm.value.isAdditionalCustomerComment,
        AdditionalCustomerCommentlnvalue:customerCommentlable,
        NeedAttention:this.addServiceForm.value.needAttention,
        RecommendedService:this.addServiceForm.value.recommendedService,
        IntegrationWithDms: this.integrationWithDms,
        RealTimeDmsSyncService: this.realTimeDmsSyncService,
        SpecialToolTypeId: this.addServiceForm.controls['specialToolTypeId'].value,
        DmsServiceId: this.addServiceForm.value.dmsServiceId,
        IsWarningLight:this.addServiceForm.value.isWarningLight,
        WarningLightId: this.selectedWarningLightString,
        AFxPackageNo: '',
        AfxPackageVersionNo: 0,
        AfxPackageMakeCode: '',
        ChargingGroupCode : this.addServiceForm.controls['chargingGroup'].value
      }

        if(!this.empty(this.addServiceForm.value.packageNo)){
          let packageObj = this.packageDropdownList.find(f=>f.selectPackage == this.addServiceForm.value.packageNo)
          viewModel.AFxPackageNo = packageObj.packageNo;
          viewModel.AfxPackageVersionNo = packageObj.packageVersionNo;
          viewModel.AfxPackageMakeCode = packageObj.makeCode;
        };
        this.spinner.show();
        this.Service.AddUpdateService(viewModel).then(res => {
          this.spinner.hide();
          this.handleAddServiceResponse(res);
        }, error => {
              this.spinner.hide();
          if(error.status === Constant.BadRequest)
          {
            this.toaster.warning(WarningMessage);
          }
          else
          {
            this.toaster.error(errorMessage);
          }
        });
    }
    handleAddServiceResponse(res){
      let successMessage = this.translate.instant("lblServiceAddedSuccessfully");
      if(res.responseCode === Constant.SuccessResponseCode)
      {
        if (res.responseObject.isSuccess) {
          this.activeModal.close({ success: true });
          this.toaster.success(successMessage);
        } else {
          const errormsg = res.responseObject.retValue === '-8000'
          ? this.translate.instant("lblAlreadyAddedService")
          : this.translate.instant("lblInternalError");
        
        this.toaster[res.responseObject.retValue === '-8000' ? 'warning' : 'error'](errormsg);
        }
      }
      else if(res.responseCode === Constant.InternalError)
      {
        let errormsg = this.translate.instant("lblInternalError");
        this.toaster.error(errormsg);
      }
      else if(res.responseCode === Constant.ResponseCode)
      {
        let errormsg = this.translate.instant("lblAlreadyAddedService");
        this.toaster.warning(errormsg);
      }
    }

    checkDiscountErrors() {
      let isError = false;
      this.ServiceFilterForm?.forEach(elementOne => {
        if (elementOne.Discount !== null) {
          elementOne.Discount = +elementOne.Discount;
          elementOne.Discount = elementOne.Discount === 0 ? null : elementOne.Discount;
          if (+elementOne.Discount > 100 || +elementOne.Discount < 0) {
            isError = true;
          }
        }
      });
      return isError;
    }

    processServiceFilterForm() {
      if (this.ServiceFilterForm?.[0].Price > 0 && this.ServiceFilterForm?.[0].Duration > 0) {
        this.ServiceFilterForm?.forEach(elementOne => {
          elementOne.Price = this.globalSetting.getFormattedprice(elementOne.Price.toString());
          elementOne.FuelTypeId?.sort((a, b) => (a.id > b.id ? 1 : -1));
          elementOne.FuelTypeId.forEach(elementTwo => {
            elementOne.FuelId += elementTwo.id + ',';
          });
        });
      } else {
        this.ServiceFilterForm = null;
      }
    }
    processWarningLight() {
      if (this.isWarningLightFeature && this.addServiceForm.value.isWarningLight) {
        if (this.selectedWarningLight.length === 0) {
          const errorMsg = this.translate.instant("lblSelectWarningLight");
          this.toaster.error(errorMsg);
          return;
        }
        this.selectedWarningLight.forEach(element => {
          this.selectedWarningLightString += element.id + ',';
        });
      }
    }
    
    public onChangeIsActive(value:boolean){
      this.addServiceForm.value.isActive = !value;
    }
      public onChangedisplayInWidget(value:boolean){
        this.addServiceForm.value.displayInWidget = !value;
        if(!this.addServiceForm.value.displayInWidget){
          this.addServiceForm.value.displayPriceInWidget = false;
        }
      }
    public onChangeIsFixed(value:any){
      this.addServiceForm.value.isFixed = !value;
      this.isAddView = this.addServiceForm.value.isFixed ? true : false;
      this.cdr.detectChanges()
    }
    public onChangeNeedAttention(value:any){
      this.addServiceForm.value.needAttention = value.target.checked;
    }
    public onChangeRecommendedService(value:any){
      this.addServiceForm.value.recommendedService = value.target.checked;
    }
    public onChangeIsWarningLight(value:any){
      this.addServiceForm.value.isWarningLight = !value;
      this.addServiceForm.controls['isWarningLight'].setValue(!value);
      if(!this.addServiceForm.value.isWarningLight)
      {
        this.selectedWarningLight=[];
        this.selectedWarningLightString='';
      }
    }

    public onChangedisplayPriceInWidget(value:boolean){
      this.addServiceForm.value.displayPriceInWidget= !value;
    }

    isDigit(event): void {
      const isDigit = Utility.isDigit(event);
      if (!isDigit) {
        event.preventDefault();
      }
    }
    CheckDuration(event){
      if(event.inputType != 'deleteContentBackward'){
      if(this.addServiceForm.value.duration.length == 2){
        this.addServiceForm.patchValue({
          duration : this.addServiceForm.value.duration + ':',
        })
      }
    }
  }
    OnClose(){
      this.activeModal.close({success:false})
    }



    AddServiceFilter( _index: number) {
      let serviceFilterViewModel: ServiceFilterViewModel = {
        BrandId: null,
        VehicleTypeId: null,
        FuelTypeId: [],
        FuelId:'',
        RangeFunctionForVehicleAge:0,
        VehicleAge:null,
        LogicFunction:0,
        Mileage:null,
        RangeFunctionForMileage:0,
        Duration:null,
        Price:null,
        PriceInclVAT:null,
        IsFixedPrice:false,
        IsShowPrice:false,
        Discount:null,
        Model:null
      };
      this.ServiceFilterForm.push(serviceFilterViewModel);
    }

    RemoveServiceFilter(index: number)
    {
        this.ServiceFilterForm.splice(index, 1);
      if (this.ServiceFilterForm.length === 0) {
        this.AddServiceFilter(0);
      }
    }

    async GetAllMake(): Promise<void> {
      await this.brandService.GetBrandDropdown().then(data => {
        this.makeList = data.responseObject;
        this.serviceDetails.makeList=this.makeList;
      });
    }

    async GetAllVehicleTypes(): Promise<void> {
      await this.checkListService.getVehicleTypes().then(data => {
          this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
          this.serviceDetails.vehicleTypes=this.vehicleTypes;
      });
    }

    async GetAllFuelTypes(): Promise<void> {
      await this.EditRentalCar.GetFuelTypes().then(data => {
        this.fuels = data.responseObject.result.slice();
        this.serviceDetails.fuels=this.MapFuelType(this.fuels);
      });
    }

    async GetAllSpecialToolTypes(): Promise<void> {
      await this.specialToolService.getAllSpecialToolTypes().then(data => {
        this.specialToolTypes = data.responseObject
      });
    }
    MapFuelType(fuelList:FuelType[])
    {
      let fuels: FuelTypeForMultiselect[]=[];
      fuelList.forEach(element => {
        let fuelDetail:FuelTypeForMultiselect=
        {
          id:element.id,
          fuelType:element.fuelType,
          description:element.description,
          fuelCodeAndType:element.fuelType+ ' - '+element.description
        }
        fuels.push(fuelDetail);
      });
      return fuels;
    }

    async getAllServices() {
      let language = this.cookieservice.get('userSelectedLanguage')
      await this.Service.getService(language,1,true)
          .then((response) => {
              this.allServices = response;
              this.allServices.forEach((service)=>{
                service.childService = service.serviceNo + " - "+ service.name
              })
          });
    }
    onChildServiceSelected(serviceId: any): void {
      if (serviceId == null) {
        this.selectedChildServices = [];
      } else {
        if (serviceId.length == 0) {
          this.selectedChildServices= [];
        }
      }
    }

    onWarningLightSelected(Id: any): void {
      if (Id == null) {
        this.selectedWarningLight = [];
      } else {
        if (Id.length == 0) {
          this.selectedWarningLight= [];
        }
      }
    }

    async getChargingGroupDropDown() {
      this.spinner.show();
      await this.laborService.getChargingGroupDropDown().then((response) => {
        this.spinner.hide()
        this.chargingGroupList = response.responseObject;
        if(this.chargingGroupList != null && this.chargingGroupList.length > 0){
          let defaultValueGroupChargingCode = this.chargingGroupList.filter((x:any)=>x.isDefault);
          if(defaultValueGroupChargingCode.length > 0 ){
            this.addServiceForm.patchValue({
              chargingGroup : defaultValueGroupChargingCode[0].groupNo
            })
          }
        }
      }, _error => {
        this.spinner.hide()
      });
    }

  }
